import React from 'react'
import { Layout } from 'react-admin'

export default props => <Layout {...props} />
